import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Table, Modal } from 'react-bootstrap';
import axios from 'axios';

const RentByCity = () => {
  const [title, setTitle] = useState('');
  const [rentList, setRentList] = useState([]); // Initialize with an empty array
  const [editId, setEditId] = useState(null); // Track the rent ID being edited
  const [showAlert, setShowAlert] = useState({ visible: false, type: '', message: '' });
  const [searchTerm, setSearchTerm] = useState(''); // Search filter for titles
  const [showModal, setShowModal] = useState(false); // Control modal visibility

  // Fetch rents by city on component mount
  useEffect(() => {
    fetchRentList();
  }, []);

  const fetchRentList = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-searchbyrent');
      setRentList(response.data.rent_by_city || []); // Access the correct key and ensure it defaults to an empty array
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Add a new rent title
      await axios.post('https://api.biznetusa.com/api/store-searchbyrent', formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Rent title added successfully' });
      setTitle('');
      fetchRentList(); // Refresh rent list after submission
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to submit data' });
    }
  };

  const handleEdit = (rent) => {
    setTitle(rent.title);
    setEditId(rent.id); // Track the ID for editing the title
    setShowModal(true); // Show the modal for editing
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Update existing rent title
      await axios.put(`https://api.biznetusa.com/api/update-searchbyrent/${editId}`, formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Rent title updated successfully' });
      setTitle('');
      setEditId(null);
      setShowModal(false); // Close modal after update
      fetchRentList(); // Refresh rent list after update
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to update data' });
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deletesearchbyrent/${id}`);
      setShowAlert({ visible: true, type: 'success', message: 'Rent title deleted successfully' });
      fetchRentList(); // Refresh rent list after deletion
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to delete rent title' });
    }
  };

  // Filtered rents based on search term
  const filteredRents = rentList.filter((rent) =>
    rent.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="mt-5">
      {/* Center the Add New Rent Title Section */}
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center mb-4">
          <h2 className="display-4">Add New Rent Title</h2>
        </Col>
      </Row>

      {/* Form for Adding New Rent Title */}
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          {showAlert.visible && (
            <Alert variant={showAlert.type} onClose={() => setShowAlert({ visible: false })} dismissible>
              {showAlert.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-white">
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter rent title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Submit New Title
            </Button>
          </Form>
        </Col>
      </Row>

      {/* Search and Table Section */}
      <Row className="justify-content-between mt-5">
        <Col>
          <h3 className="text-center">Existing Rent Titles</h3>
        </Col>
        <Col md={4} className="text-right">
          <Form.Control
            type="text"
            placeholder="Search by title"
            value={searchTerm}
            onChange={handleSearchChange}
            className="shadow-sm"
          />
        </Col>
      </Row>

      {/* Table to display filtered rents */}
      <Table striped bordered hover responsive="md" className="mt-3 shadow-sm bg-white">
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRents.map((rent, index) => (
            <tr key={rent.id}>
              <td className="align-middle text-center">{index + 1}</td>
              <td className="align-middle text-left">{rent.title}</td>
              <td className="align-middle text-center">
                <Button
                  variant="info"
                  className="mr-2 btn-sm"
                  onClick={() => handleEdit(rent)}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  className="btn-sm"
                  onClick={() => handleDelete(rent.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for updating the rent title */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Rent Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdate}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter new rent title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Update Title
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default RentByCity;
